<template>
  <div
    class="dashboard-increase-indicator"
    :class="{
      increasing,
      decreasing,
      stable,
      inversed,
      'no-background': noBackground
    }"
  >
    <v-icon class="indicator">{{ icon }}</v-icon>
    <span class="value"
      >{{ floatValue ? Math.abs(value.toFixed(1)) : Math.abs(value.toFixed(0))
      }}{{ showUnit ? unit : "" }}</span
    >
  </div>
</template>

<script>
export default {
  name: "DashboardIncreaseIndicator",
  props: {
    value: {
      type: Number,
      required: true
    },
    inversed: {
      type: Boolean,
      default: false
    },
    noBackground: {
      type: Boolean,
      default: false
    },
    floatValue: {
      type: Boolean,
      default: false
    },
    showUnit: {
      type: Boolean,
      default: true
    },
    unit: {
      type: String,
      default: "%"
    }
  },
  computed: {
    increasing() {
      return this.value > 0;
    },
    decreasing() {
      return this.value < 0;
    },
    stable() {
      return this.value === 0;
    },
    icon() {
      if (this.stable) {
        return "mdi-record";
      }
      return this.increasing ? "mdi-menu-up" : "mdi-menu-down";
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-increase-indicator {
  display: inline-flex;
  align-items: center;

  &.no-background {
    background: none !important;

    .value,
    .indicator {
      font-weight: normal;
      line-height: 17px;
    }
  }

  &:not(.no-background) {
    padding: $spacing / 2 $spacing * 2 $spacing / 2 $spacing;
    border-radius: 23px;
  }

  .value,
  .indicator {
    font-weight: 500;
    line-height: 24px;
  }

  &.increasing {
    background: $dashboard-positive-bg-color;

    .value,
    .indicator {
      color: $dashboard-positive-color;
    }
  }

  &.decreasing {
    background: $dashboard-negative-bg-color;

    .value,
    .indicator {
      color: $dashboard-negative-color;
    }
  }

  &.stable {
    background: rgba($text, 0.1);

    .value,
    .indicator {
      color: $text;
    }

    .indicator {
      width: 24px;
      @include font-size(8px);
    }
  }

  .none {
    visibility: hidden;
    width: 10px;
  }
}
</style>
